import { render } from "./Reminders.vue?vue&type=template&id=63da5ea8&scoped=true&ts=true"
import script from "./Reminders.vue?vue&type=script&lang=ts"
export * from "./Reminders.vue?vue&type=script&lang=ts"

import "./Reminders.vue?vue&type=style&index=0&id=63da5ea8&lang=scss&scoped=true"

import exportComponent from "/var/www/tenanthub.au/runners/admin/root/tenanthub-admin/tenanthub-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63da5ea8"]])

export default __exports__